// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"78d494a733cb92e4e896","418":"84124e95cdc4d56dc66c","661":"559f01c9f922fa1660d6"}[chunkId] + ".bundle.js";
};